import { AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { snakizeObject } from '@cvt/helpers/object';

import { mapGiftCrudData, mapGiftData } from './giftClient.formatter';

const giftsApiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getGift = (params: { id: number | string }): Promise<AxiosResponse<Gift.Gift>> => {
  return request({
    options: {
      url: `${giftsApiBaseUrl}/gifts/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Gift.GiftApi>) => ({
    ...data,
    data: mapGiftData(data.data),
  }));
};

const getGifts = (params: Gift.GetListParams): Promise<AxiosResponse<CVT.Query.PaginatedResults<Gift.Gift>>> => {
  return request({
    options: {
      url: `${giftsApiBaseUrl}/gifts/`,
      method: 'GET',
      params: snakizeObject(params),
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<Gift.GiftApi>>) => ({
    ...data,
    data: {
      ...data.data,
      results: data.data.results.map(mapGiftData),
    },
  }));
};

const createGift = (data: Gift.Create): Promise<AxiosResponse<Gift.Gift>> => {
  return request({
    options: {
      url: `${giftsApiBaseUrl}/gifts/`,
      method: 'POST',
      data: mapGiftCrudData(data),
    },
  }).then((data: AxiosResponse<Gift.GiftApi>) => ({
    ...data,
    data: mapGiftData(data.data),
  }));
};

const editGift = (data: Gift.Edit): Promise<AxiosResponse<Gift.Gift>> => {
  return request({
    options: {
      url: `${giftsApiBaseUrl}/gifts/${data.id}/`,
      method: 'PUT',
      data: mapGiftCrudData(data),
    },
  }).then((data: AxiosResponse<Gift.GiftApi>) => ({
    ...data,
    data: mapGiftData(data.data),
  }));
};

const deleteGift = (params: { id: number | string }): Promise<AxiosResponse> => {
  return request({
    options: {
      url: `${giftsApiBaseUrl}/gifts/${params.id}/`,
      method: 'DELETE',
    },
  });
};

export const giftClient = {
  getGift,
  getGifts,
  createGift,
  editGift,
  deleteGift,
};